<template>
  <div class="details-view">
    <cargo-left-right-resize
      :left-style="{flex:'none','max-width':'220px'}"
      :right-style="{'overflow': 'hidden'}"
      :show-left="action==='look'"
      style="min-height:100%"
    >
      <template v-show="action==='look'" slot="left">
        <div style="min-width: 180px;width:100%;height:100%;padding:10px 0px 10px;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="gridOptions.columnDefs"
            :row-data="rowData"
            style="width:100%;height:100%;min-height: 500px;padding-left: 16px;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </template>
      <template slot="right">
        <div class="main-content">
          <div class="operations" style="margin-bottom: 5px">
            <div class="triggers" style="flex:none">
              <cargo-button-group-slider>
                <div v-show="action==='look'">
                  <!--返回-->
                  <el-button no="back" type="primary" @click="goBack">{{ $t('common.btn.back') }}</el-button>
                  <!--编辑-->
                  <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_editOverSeaWarehouse'])" no="edit" type="success" @click="editHandler()">{{ $t('SeaExport.Edit') }}</el-button>
                  <!--打印-->
                  <el-button v-if="$checkPermission(['button_FBAOverseaWarehousing_printOverSeaWarehouse'])" no="print1" :disabled="isEditing" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
                </div>
                <div v-show="(isNew || action==='edit')" class="new" style="border-left:none;padding-left:0">
                  <!--保存-->
                  <el-button v-show="isNormal" no="onlySave" type="success" @click="onlySave">{{ $t('common.btn.save') }}</el-button>
                  <!--                  &lt;!&ndash;保存并称重&ndash;&gt;
                  <el-button no="saveAndWeigh" v-show="isNormal" type="success" @click="saveAndWeigh">{{ $t('Warehouse.SaveAndWeigh') }}</el-button>
                  &lt;!&ndash;保存并核单&ndash;&gt;
                  <el-button no="saveAndChecklist" v-show="isNormal" type="success" @click="saveAndChecklist">{{ $t('Warehouse.SaveAndChecklist') }}</el-button>
                  &lt;!&ndash;称重&ndash;&gt;
                  <el-button no="weigh" v-show="isWeigh" type="success" @click="onlyWeigh">{{ $t('Warehouse.Weigh') }}</el-button>
                  &lt;!&ndash;称重并核单&ndash;&gt;
                  <el-button no="weighAndChecklist" v-show="isWeigh" type="success" @click="weighAndChecklist">{{ $t('Warehouse.WeighAndChecklist') }}</el-button>
                  &lt;!&ndash;核单&ndash;&gt;
                  <el-button no="checklist" v-show="isChecklist" type="success" @click="onlyChecklist">{{ $t('Warehouse.Checklist') }}</el-button>-->
                  <el-button no="cancel2" type="success" @click="cancelEdit()">{{ $t('common.btn.cancel') }}</el-button>
                  <el-button v-show="!isEditing" v-if="$checkPermission(['button_FBAOverseaWarehousing_printOverSeaWarehouse'])" no="print3" type="primary" @click="onPrintHandler()">{{ $t('SeaExport.print') }}</el-button>
                </div>
              </cargo-button-group-slider>
            </div>
          </div>
          <div class="tabs-container" style="position: relative">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              style="width:100%"
              @tab-click="handleTabClick"
            >
              <el-tab-pane :key="1" :label="$t('Message.Main')" :lazy="true" name="baseInfo">
                <fba-oversea-warehousing-detail ref="baseInfo" :lob="lob" :action="action" :warehouse-in-uuid="currentRow.uuid" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew" :key="2" label="出库管理" :lazy="true" name="outWareHouse">
                <fba-out-warehouse ref="outWareHouse" :action="action" :context="parentContext" @success="onRefresh" />
              </el-tab-pane>
              <el-tab-pane v-if="!isNew && currentRow.pallet && $checkPermission(['tab_FBAOverseaWarehousing_playJoeTab'])" :key="3" :label="$t('Warehouse.DaycareInformation')" :lazy="true" name="fbaPallet">
                <fba-pallet ref="fbaPallet" :action="action" :context="parentContext" @success="onRefresh" />
              </el-tab-pane>
              <el-tab-pane v-if="$checkPermission(['tab_FBAOverseaWarehousing_overSeaFileTab'])" :key="4" :label="$t('SeaExport.FileHistory')" :lazy="true" name="fileHistory">
                <tab-file-history ref="fileHistory" :context="parentContext" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
  </div>
</template>

<script>
import locationImg from '@/assets/location24.png'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { getLoading } from '@/utils/utilBaseElement'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import { fbaSaveFunc, checkWarehouseNo } from '@/api/warehouseIn/warehouseIn'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import moment from 'moment'
import FbaWarehousingDetail from '@/views/cargo/v0/FBA/Warehousing/fbaWarehousingDetail'
import DateUtils from '@/utils/dateUtils'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { TabError } from '@/utils/class/TabError'
import tabFileHistory from '@/components/Cargo/Job/booking/tabs/tabFileHistory'
import FbaPallet from '@/views/cargo/v0/FBA/Warehousing/fbaPallet'
import FbaOverseaWarehousingDetail from '@/views/cargo/v0/FBA/OverseaWarehousing/fbaOverseaWarehousingDetail'
import FbaOutWarehouse from '@/views/cargo/v0/FBA/OverseaWarehousing/fbaOutWarehouse'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
export default {
  name: 'FbaOverseaWarehousingWorkspace',
  components: {
    FbaOutWarehouse,
    FbaOverseaWarehousingDetail,
    FbaPallet,
    tabFileHistory,
    FbaWarehousingDetail,
    DropUploader,
    cargoAdvanceSelect,
    cargoLeftRightResize,
    cargoUserSelect,
    CargoButtonGroupSlider
  },
  props: {
    parentContext: {
      type: Object,
      required: true
    },
    lob: { type: String, required: true },
    opType: { type: String, required: false }
  },
  data() {
    return {
      locationImg,
      URL,
      selectTypeNames: TYPE_NAMES,
      SystemConstants,
      action: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        columnDefs: [
          { headerName: this.$t('Warehouse.WarehouseNo'), field: 'warehouseNo', minWidth: 160, colId: 'warehouseNo' }
        ],
        onRowClicked: this.changeWareHouseIn
      },
      rowData: [],
      gridApi: null,
      pendTabSet: new Set(),
      currentRow: {},
      initWarehouseNo: '',
      isGetInfoFromDb: false, // 从数据库获取信息
      activeTabName: 'baseInfo'
    }
  },
  computed: {
    isFba() { // 是否fba
      return this.lob === 'FBA'
    },
    user() {
      return this.$store.getters.userId
    },
    isNew() {
      return this.action === 'add'
    },
    isEditing() {
      return this.action !== 'look'
    },
    isWeigh() { // 是否称重
      return this.opType === 'weigh'
    },
    isChecklist() { // 是否核单
      return this.opType === 'checklist'
    },
    isNormal() { // 正常编辑
      return !this.isWeigh && !this.isChecklist
    }
  },
  methods: {
    // 公用方法，进入详情每个页签都会调用
    async onShow(action, rowData, selectedRow) {
      this.isGetInfoFromDb = true
      this.currentRow = selectedRow
      this.initWarehouseNo = selectedRow.warehouseNo
      this.action = action
      this.$nextTick(() => {
        this.resetActiveTabName()
      })
      if (!selectedRow.uuid) {
        this.buildNewRow(selectedRow)
        this.rowData = [...rowData, selectedRow]
      } else {
        this.rowData = [...rowData]
      }
      this.$nextTick(async() => {
        if (this.gridApi) {
          await sleep(100)
        } else {
          // 等待gridApi被赋值
          await ensureExecuteSuccess(() => this.gridApi)
        }
        // this.gridApi.clearFocusedCell()
        await this.onRowClicked({ data: selectedRow })
      })
    },
    resetActiveTabName() {
      if (this.isNew) {
        this.activeTabName = this.getDefaultActiveName()
      } else {
        const activePanes = this.$refs['tabs'].panes.filter(p => p.active)
        if (activePanes && activePanes.length === 0) {
          this.activeTabName = this.getDefaultActiveName()
        }
      }
    },
    getDefaultActiveName() {
      const firstPane = this.$refs['tabs'].panes[0]
      return firstPane ? firstPane.name : ''
    },
    // 设置选中行
    setGridSelect(row) {
      const nodes = this.gridApi.getRenderedNodes()
      for (const item of nodes) {
        if (!item.data) {
          continue
        }
        const itemKey = item.data.uuid
        const rowKey = row.uuid
        if (itemKey === rowKey || !itemKey) {
          item.setSelected(true)
          item.setData(item.data)
          this.gridApi.ensureIndexVisible(item.rowIndex)
          break
        }
      }
    },
    // 新增时 填充默认值
    buildNewRow(selectedRow) {
      selectedRow = new WarehouseIn().fillDefaultValue().getData()
      selectedRow.warehouseOp = this.$store.getters.userId
      selectedRow.warehouseInDate = DateUtils.formatStandardDateTime(new Date())
    },
    async changeWareHouseIn(event) {
      const result = event.data
      if (result) {
        for (const key in result) {
          if (typeof result[key] === 'object') {
            result[key] = ''
          }
        }
        this.isGetInfoFromDb = true
        await this.onRowClicked({ data: result })
      }
    },
    // 行点击
    async onRowClicked(event) {
      if (!event.data) {
        return
      }
      const warehouse = event.data
      this.setGridSelect(warehouse)

      if (this.isGetInfoFromDb && warehouse.uuid) {
        const jobModel = new WarehouseIn(warehouse)
        this.loading = getLoading()
        await jobModel.loadWarehouseInRelated({
          warehouseIn: true,
          businessDocument: true,
          operationRequirement: true,
          warehouseInDetail: true,
          outWarehouse: true,
          pallets: true,
          fbaJobGoods: true
        }).finally(() => {
          this.loading.close()
        })
        this.isGetInfoFromDb = false
      }
      if (!warehouse.businessDocumentVOList) warehouse.businessDocumentVOList = []
      if (!warehouse.operationRequirementVOList) warehouse.operationRequirementVOList = []
      if (!warehouse.warehouseInDetailList) warehouse.warehouseInDetailList = []
      if (!warehouse.fbaPallets) warehouse.fbaPallets = []
      if (!warehouse.fbaOutWarehouses) warehouse.fbaOutWarehouses = []
      if (!warehouse.fbaJobGoods) warehouse.fbaJobGoods = []
      this.currentRow = warehouse
      this.pendTabSet.clear()
      this.$nextTick(() => {
        this.resetActiveTabName()
        this.handleTabClick()
      })
    },
    // tab页签切换
    handleTabClick() {
      const oldSize = this.pendTabSet.size
      this.pendTabSet.add(this.activeTabName)
      const isRefresh = this.pendTabSet.size > oldSize
      this.$nextTick(() => {
        this.currentRow.className = 'WarehouseIn'
        this.$refs[this.activeTabName].onShow(this.currentRow, isRefresh)
      })
    },
    beforeLeaveTab(activeName, oldActiveName) {
      if (oldActiveName) {
        this.endTabHandler(oldActiveName)
      }
      return true
    },
    // 编辑
    editHandler(row) {
      if (!row) {
        row = this.currentRow
      }
      let msg = ''
      if (!row.outWarehouseStatus || Number(row.outWarehouseStatus) === Number(FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_NO_WAREHOUSING.code)) {
        msg = FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_NO_WAREHOUSING.chineseName
      } else if (Number(row.outWarehouseStatus) === Number(FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_ISSUED.code)) {
        msg = FbaJobConstants.OVERSEA_WAREHOUSE_STATUS_ISSUED.chineseName
      }
      if (msg) {
        this.$message.warning(msg + '不允许编辑国外仓信息。')
        return
      }
      this.onShow('edit', this.rowData, row)
    },
    // 打印
    onPrintHandler() {
      const rows = []
      rows.push(this.currentRow)
      this.$emit('print', rows)
    },
    saveHandler(res) {
      this.loading.close()
      this.$message.success(this.$t('Message.SavedSuccessfully'))
      const result = res.data
      if (result) {
        for (const key in result) {
          this.currentRow[key] = result[key]
        }
      }
      this.onShow('look', this.rowData, this.currentRow)
    },
    // 取消编辑
    cancelEdit() {
      this.$confirm(this.$t('CargoMsg.Cargo_CCOCM'), this.$t('common.tips.confirm'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.onShow('look', this.rowData, this.currentRow)
      }).catch(() => { })
    },
    goBack() {
      this.activeTabName = 'baseInfo'
      this.action = ''
      this.isGetInfoFromDb = true
      this.$emit('back', true)
    },
    // 新增
    onAdd() {
      this.$emit('add')
    },
    // 刷新
    onRefresh() {
      this.isGetInfoFromDb = true
      this.changeWareHouseIn({ data: this.currentRow })
    },
    // fba保存公共
    async fbaSave(opType) {
      this.loading = getLoading()
      const body = {}
      try {
        const pendTabSet = [...this.pendTabSet]
        for (const item of pendTabSet) {
          let tabData = null
          // 各页签的保存数据
          const getSubmitData = this.$refs[item].getSubmitData
          if (getSubmitData && typeof getSubmitData === 'function') {
            /* 获取各页签需要保存的数据 */
            const result = this.$refs[item].getSubmitData()
            if (result instanceof Promise) {
              tabData = await result
            } else {
              tabData = result
            }
          }
          if (!tabData) continue
          Object.assign(body, tabData)
          // this.$logger.log('页签名称：' + item, tabData)
        }
      } catch (err) {
        if (err instanceof TabError) {
          this.loading.close()
          this.activeTabName = err.tabName
          if (err.message) {
            this.$message.warning({ dangerouslyUseHTMLString: true, message: err.message })
          }
          return
        }
        throw err
      }
      // 保存前验证
      this.$logger.log('保存前验证 fbaSaveFunc-body', body)
      if (!await this.checkFbaSave(body, opType)) {
        this.loading.close()
        return
      }
      this.$logger.log('验证后 fbaSaveFunc-body', body)
      body.action = this.action
      body.warehouseInUuid = this.currentRow.uuid || ''
      fbaSaveFunc(body).then(resp => {
        this.saveHandler(resp)
      }).finally(() => this.loading.close())
    },
    async checkFbaSave(body, opType) {
      const checkForm = body.fbaWarehouseInVO
      if (!checkForm.warehouseNo) {
        this.$message.warning(this.$t('Message.PleaseEnterTheWarehousingNumber'))
        return false
      }
      if (!checkForm.warehouse) {
        this.$message.warning(this.$t('Message.PleaseEnterTheWarehouseName'))
        return false
      }
      if (checkForm.sealCargo && checkForm.sealWeight === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectTheClosingWeight'))
        return false
      }

      // 验证进仓编号是否重复
      let isContinue = true
      if (checkForm.warehouseNo !== this.initWarehouseNo) {
        const item = {}
        item.anyStr = checkForm.warehouseNo
        item.anyStr1 = checkForm.uuid
        const count = await checkWarehouseNo(item).then(res => res.data).catch(() => this.loading.close())
        if (count && count > 0) {
          if (this.loading) this.loading.close()
          await this.$confirm(this.$t('Message.WarehouseNumberAlreadyExistsContinue'), this.$t('common.tips.confirm'), {
            confirmButtonText: this.$t('common.btn.yes'),
            cancelButtonText: this.$t('common.btn.no'),
            closeOnClickModal: false,
            type: 'info'
          }).then(() => {
            this.loading = getLoading()
          }).catch(() => {
            isContinue = false
          })
        }
      }
      if (!isContinue) return

      // 特殊保存
      if (!opType) return true
      if (opType === 'weigh') { // 称重
        if (!checkForm.weighTime) {
          this.$message.warning(this.$t('Warehouse.WeighTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return false
        }
      } else if (opType === 'checklist') { // 核单
        if (!checkForm.checklistTime) {
          this.$message.warning(this.$t('Warehouse.ChecklistTime') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return false
        }
        if (!checkForm.checklistStatus && Number(checkForm.checklistStatus) !== 0) {
          this.$message.warning(this.$t('Warehouse.ChecklistResult') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return false
        }
        if (checkForm.weighTime) {
          const weighTime = moment(checkForm.weighTime).format('YYYY-MM-DD HH:mm')
          const checklistTime = moment(checkForm.checklistTime).format('YYYY-MM-DD HH:mm')
          if (weighTime > checklistTime) {
            this.$message.warning(this.$t('Warehouse.ChecklistTimeTip', [checklistTime, weighTime]))
            return false
          }
        }
      }

      // 称重、核单公共校验
      if (!body.warehouseInDetailList || body.warehouseInDetailList.length <= 0) {
        this.$message.warning(this.$t('Warehouse.CargoDetails') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      if (!checkForm.quantitySum || Number(checkForm.quantitySum) <= 0) {
        this.$message.warning(this.$t('Warehouse.NumberOfCases') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      if (!checkForm.weightSum || Number(checkForm.weightSum) <= 0) {
        this.$message.warning(this.$t('Warehouse.Weight') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      if (!checkForm.cubageSum || Number(checkForm.cubageSum) <= 0) {
        this.$message.warning(this.$t('Warehouse.Volume') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      return true
    },
    // 仅保存
    onlySave() {
      this.fbaSave()
    },
    // 保存并称重
    saveAndWeigh() {
      this.fbaSave('weigh')
    },
    // 保存并核单
    async saveAndChecklist() {
      this.fbaSave('checklist')
    },
    // 称重
    async onlyWeigh() {
      this.fbaSave('weigh')
    },
    // 称重并核单
    async weighAndChecklist() {
      this.fbaSave('checklist')
    },
    // 核单
    async onlyChecklist() {
      this.fbaSave('checklist')
    }
  }
}
</script>

<style lang="scss">
.booking-details {
  .el-tabs__nav-prev,.el-tabs__nav-next{
    line-height: 29px;
  }
  .el-tabs__content{
    overflow: auto
  }
  .warehousingDetail{
    height: 100%;
  }
}
</style>
